import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    subscribeToNewsletter,
    updateNewsletterError,
} from '@client/redux/modules/newsletter/actions';
import { getNewsletterError } from '@client/redux/modules/newsletter/selectors';

import { SubscriptionTarget } from './types';
import { useSubscriptionFlowProps } from '.';

export const useSubscriptionFlow = (
    subscriptionTarget: SubscriptionTarget,
): useSubscriptionFlowProps => {
    const dispatch = useDispatch();

    const error = useSelector(getNewsletterError);

    const [rejected, setRejected] = useState(false);
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
        dispatch(updateNewsletterError);
    }, [dispatch]);

    const reject = useCallback(() => {
        setRejected(true);
    }, []);

    const confirmEmail = useCallback(
        (emailProvider: string) => () => {
            window.open(`http://www.${emailProvider}`, '_blank');
        },
        [],
    );

    const subscribe = useCallback(() => {
        setAccepted(true);
        dispatch(subscribeToNewsletter(subscriptionTarget));
    }, [dispatch, subscriptionTarget]);

    return {
        rejected,
        accepted,
        error,
        subscribe,
        reject,
        confirmEmail,
    };
};
